import styles from './VServicesModalRepairDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image from './image.jpg'

const VServicesModalRepairDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Ремонт питьевых аппаратов</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Гарантийные обязательства утрачивают свою силу в случаях:
                        </div>
                        <div className={styles.text}>
                            <ul>
                                <li>повреждения, вызванного механическим, электрическим или тепловым воздействием</li>
                                <li>повреждения, вызванного неправильной эксплуатацией (нарушение инструкции по эксплуатации)</li>
                                <li>в случае несанкционированного вскрытия, ремонта</li>
                                <li>небрежного обращения</li>
                                <li>при отсутствии гарантийного талона, или при наличии в нем исправлений</li>
                                <li>оплавившейся термоизоляции на бачке горячей воды, что свидетельствует о включении аппарата в электросеть с незаполненным водой бачком горячей воды</li>
                                <li>несоблюдением санитарных норм</li>
                                <li>проникновением насекомых, мышей внутрь аппарата</li>
                            </ul>
                        </div>
                    </div>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Внимание! При несоблюдении правила эксплуатации в течение гарантийного срока ремонт производится за счет клиента.
                        </div>
                        <div className={styles.text}>
                            <p>Как любой сложный прибор, аппарат требует соблюдения определенных правил эксплуатации – они описаны в инструкции по эксплуатации.</p>
                            <p>Аппарат принимается на ремонт очищенным от пыли, грязи и отсутствием воды в системе. Предусмотрена доставка аппаратов от клиента в мастерскую и обратно.</p>
                        </div>
                    </div>
                    
                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image} alt="Ремонт аппаратов" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalRepairDetails;